module.exports = __webpack_public_path__ + "images/category_lp/brand/banner_f8ff30151f4f9eb39e0ff20b7f7bb047.png";